import { useAuth } from "@clerk/tanstack-react-start";
import { useNavigate, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

import { invalidateClientClerkAuthCache, primeClientClerkAuthCache } from "@/routes/__root";

export function useRedirectAfterAuth(to: string = "/app", enabled: boolean = true) {
  const { isSignedIn, userId } = useAuth();
  const router = useRouter();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSignedIn && userId && enabled) {
      let cancelled = false;
      invalidateClientClerkAuthCache();

      void (async () => {
        if (cancelled) return;

        primeClientClerkAuthCache({ userId, token: null });
        await router.invalidate();

        if (!cancelled) {
          navigate({ to });
        }
      })();

      return () => {
        cancelled = true;
      };
    }
  }, [isSignedIn, userId, enabled, router, navigate, to]);
}
